import {NgModule} from '@angular/core';
import {IonicModule} from '@ionic/angular';
import {SharedModule} from '../../shared/shared.module';
import {PrivacyPage} from './privacy';

@NgModule({
  declarations: [
    PrivacyPage,
  ],
 
  imports: [
    IonicModule,
    SharedModule
  ],
})
export class PrivacyPageModule {
}
